import React, { useState, useEffect } from 'react';

export default function ButtonsModal({ open, onClose, node, onSave }) {
  const [formData, setFormData] = useState({
    message: '',
    buttons: [
      { label: 'Option 1', action: 'reply', value: '' },
      { label: 'Option 2', action: 'reply', value: '' }
    ],
    maxButtons: 3,
    delay: 0
  });
  const [newButton, setNewButton] = useState('');

  useEffect(() => {
    if (open && node) {
      setFormData({
        message: node.data.message || '',
        buttons: node.data.buttons || [
          { label: 'Option 1', action: 'reply', value: '' },
          { label: 'Option 2', action: 'reply', value: '' }
        ],
        maxButtons: node.data.maxButtons || 3,
        delay: node.data.delay || 0
      });
    }
  }, [open, node]);

  const handleSave = () => {
    if (onSave) {
      onSave(node.id, formData);
    }
    onClose();
  };

  const addButton = () => {
    if (newButton.trim() && formData.buttons.length < formData.maxButtons) {
      setFormData(prev => ({
        ...prev,
        buttons: [...prev.buttons, { label: newButton.trim(), action: 'reply', value: '' }]
      }));
      setNewButton('');
    }
  };

  const removeButton = (index) => {
    setFormData(prev => ({
      ...prev,
      buttons: prev.buttons.filter((_, i) => i !== index)
    }));
  };

  const updateButton = (index, field, value) => {
    setFormData(prev => ({
      ...prev,
      buttons: prev.buttons.map((button, i) => 
        i === index ? { ...button, [field]: value } : button
      )
    }));
  };

  if (!open) return null;

  const modalStyle = {
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    background: 'rgba(0,0,0,0.5)',
    zIndex: 10000,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '20px'
  };

  const contentStyle = {
    background: '#ffffff',
    borderRadius: '8px',
    padding: '24px',
    minWidth: '500px',
    maxWidth: '600px',
    maxHeight: '80vh',
    overflowY: 'auto',
    boxShadow: '0 4px 20px rgba(0,0,0,0.15)'
  };

  const inputStyle = {
    width: '100%',
    border: '1px solid #d1d5db',
    borderRadius: '4px',
    padding: '8px 12px',
    fontSize: '14px',
    marginBottom: '12px',
    outline: 'none'
  };

  const textareaStyle = {
    width: '100%',
    border: '1px solid #d1d5db',
    borderRadius: '4px',
    padding: '12px',
    fontSize: '14px',
    marginBottom: '12px',
    outline: 'none',
    minHeight: '80px',
    resize: 'vertical',
    fontFamily: 'inherit'
  };

  const buttonStyle = {
    background: '#007bff',
    color: '#ffffff',
    border: 'none',
    borderRadius: '4px',
    padding: '8px 16px',
    fontSize: '14px',
    cursor: 'pointer',
    marginRight: '8px'
  };

  const secondaryButtonStyle = {
    background: '#6c757d',
    color: '#ffffff',
    border: 'none',
    borderRadius: '4px',
    padding: '8px 16px',
    fontSize: '14px',
    cursor: 'pointer'
  };

  const smallButtonStyle = {
    background: '#dc3545',
    color: '#ffffff',
    border: 'none',
    borderRadius: '4px',
    padding: '4px 8px',
    fontSize: '12px',
    cursor: 'pointer'
  };

  const buttonItemStyle = {
    border: '1px solid #d1d5db',
    borderRadius: '4px',
    padding: '12px',
    marginBottom: '8px',
    background: '#f8f9fa'
  };

  return (
    <div style={modalStyle} onClick={onClose}>
      <div style={contentStyle} onClick={e => e.stopPropagation()}>
        {/* Header */}
        <div style={{ textAlign: 'center', marginBottom: '20px' }}>
          <h2 style={{ margin: 0, color: '#495057', fontSize: '20px', fontWeight: '600' }}>
            Configure Quick Reply Buttons
          </h2>
        </div>

        {/* Message */}
        <div style={{ marginBottom: '20px' }}>
          <label style={{ display: 'block', marginBottom: '8px', fontWeight: '500', color: '#495057' }}>
            Message
          </label>
          <textarea
            value={formData.message}
            onChange={e => setFormData(prev => ({ ...prev, message: e.target.value }))}
            placeholder="Enter the message that will be shown with the buttons..."
            style={textareaStyle}
          />
        </div>

        {/* Buttons Configuration */}
        <div style={{ marginBottom: '20px' }}>
          <label style={{ display: 'block', marginBottom: '8px', fontWeight: '500', color: '#495057' }}>
            Quick Reply Buttons ({formData.buttons.length}/{formData.maxButtons})
          </label>
          
          {formData.buttons.map((button, index) => (
            <div key={index} style={buttonItemStyle}>
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '8px' }}>
                <span style={{ fontSize: '14px', fontWeight: '500', color: '#495057' }}>
                  Button {index + 1}
                </span>
                <button
                  onClick={() => removeButton(index)}
                  style={smallButtonStyle}
                >
                  ✕ Remove
                </button>
              </div>
              
              <input
                type="text"
                value={button.label}
                onChange={e => updateButton(index, 'label', e.target.value)}
                placeholder="Button text"
                style={{ ...inputStyle, marginBottom: '8px' }}
              />
              
              <select
                value={button.action}
                onChange={e => updateButton(index, 'action', e.target.value)}
                style={{ ...inputStyle, marginBottom: '8px' }}
              >
                <option value="reply">Reply</option>
                <option value="url">Open URL</option>
                <option value="phone">Call Phone</option>
                <option value="copy">Copy Text</option>
              </select>
              
              {button.action === 'url' && (
                <input
                  type="url"
                  value={button.value}
                  onChange={e => updateButton(index, 'value', e.target.value)}
                  placeholder="Enter URL"
                  style={inputStyle}
                />
              )}
              
              {button.action === 'phone' && (
                <input
                  type="tel"
                  value={button.value}
                  onChange={e => updateButton(index, 'value', e.target.value)}
                  placeholder="Enter phone number"
                  style={inputStyle}
                />
              )}
              
              {button.action === 'copy' && (
                <input
                  type="text"
                  value={button.value}
                  onChange={e => updateButton(index, 'value', e.target.value)}
                  placeholder="Text to copy"
                  style={inputStyle}
                />
              )}
            </div>
          ))}
          
          {formData.buttons.length < formData.maxButtons && (
            <div style={{ display: 'flex', gap: '8px', marginTop: '12px' }}>
              <input
                type="text"
                value={newButton}
                onChange={e => setNewButton(e.target.value)}
                placeholder="New button text"
                style={{ flex: 1, ...inputStyle, marginBottom: 0 }}
                onKeyPress={e => e.key === 'Enter' && addButton()}
              />
              <button
                onClick={addButton}
                style={buttonStyle}
              >
                + Add
              </button>
            </div>
          )}
        </div>

        {/* Maximum Buttons Setting */}
        <div style={{ marginBottom: '20px' }}>
          <label style={{ display: 'block', marginBottom: '8px', fontWeight: '500', color: '#495057' }}>
            Maximum Buttons - {formData.maxButtons}
          </label>
          <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
            <input
              type="range"
              min="1"
              max="10"
              value={formData.maxButtons}
              onChange={e => setFormData(prev => ({ ...prev, maxButtons: parseInt(e.target.value) }))}
              style={{ flex: 1 }}
            />
            <span style={{ fontSize: '14px', color: '#6c757d', minWidth: '30px' }}>
              {formData.maxButtons}
            </span>
          </div>
        </div>

        {/* Delay Setting */}
        <div style={{ marginBottom: '24px' }}>
          <label style={{ display: 'block', marginBottom: '8px', fontWeight: '500', color: '#495057' }}>
            Delay before showing buttons - {formData.delay} sec
          </label>
          <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
            <input
              type="range"
              min="0"
              max="10"
              value={formData.delay}
              onChange={e => setFormData(prev => ({ ...prev, delay: parseInt(e.target.value) }))}
              style={{ flex: 1 }}
            />
            <span style={{ fontSize: '14px', color: '#6c757d', minWidth: '50px' }}>
              {formData.delay} sec
            </span>
          </div>
        </div>

        {/* Action Buttons */}
        <div style={{ display: 'flex', justifyContent: 'space-between' }}>
          <button
            onClick={handleSave}
            style={{ ...buttonStyle, display: 'flex', alignItems: 'center', gap: '6px' }}
          >
            💾 Save
          </button>
          <button
            onClick={onClose}
            style={{ ...secondaryButtonStyle, display: 'flex', alignItems: 'center', gap: '6px' }}
          >
            ✕ Close
          </button>
        </div>
      </div>
    </div>
  );
} 